export const locale = {
  lang: 'nl',
  data: {
    'CHANGELOG': {
      'TITULO': 'Wijzigingslog',
      'SUBTITULO': 'Controleer de updates die in de loop van de tijd op het platform zijn aangebracht',
      'ULTIMA': 'Laatste update',
      'CATEGORIAS': {
        'Changed': 'Updates',
        'Fixed': 'reparaties',
        'Added': 'Verbeteringen'
      }
    },
    'KNOWLEDGE': {
      'LINK': 'Klik op deze link als het platform u niet automatisch omleidt'
    }
  }
};
